

























import { Vue, Component, Prop } from 'vue-property-decorator';
@Component
export default class KAsync extends Vue {
  @Prop(String) readonly title: string | undefined;
}
